import React, { useState }  from 'react'
import { Skeleton, } from "@chakra-ui/react"

export default function GalleryImage(props) {
     const [isloaded, imageLoad] = useState(false);
     const imageStyle = !isloaded ? { display: "none" } : {};
     const placeholder = !isloaded ?<Skeleton height="30vh" width="100%"  />:null
    return (
        <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="single-gallery-box">
                        {placeholder}
                        <img src={props.image} alt="Gallery Content" style={imageStyle} onLoad={imageLoad}/>
                        <a href={props.image} alt="" className="gallery-btn" data-imagelightbox="popup-btn">
                            <i className="flaticon-search"></i>
                        </a>
                    </div>
        </div>
    )
}
